<template>
  <div class="row">
    <card class="col-md-5" title="Quantidade de empréstimos por tag">
      <dados-estatisticos-biblioteca endpoint='tags' propriedadeNome='nome_tag'/>
    </card>
    <card class="col-md-5 col-md-offset-1" title="Quantidade de empréstimos por categoria">
      <dados-estatisticos-biblioteca endpoint='categorias' propriedadeNome='nome_categoria'/>
    </card>
    <card class="col-md-5" title="Quantidade de empréstimos por autor">
      <dados-estatisticos-biblioteca endpoint='autores' propriedadeNome='nome_autor'/>
    </card>
    <card class="col-md-5 col-md-offset-1" title="Quantidade de empréstimos por livro">
      <dados-estatisticos-biblioteca endpoint='livros' propriedadeNome='titulo'/>
    </card>
  </div>
</template>
<script>
import DadosEstatisticosBiblioteca from '@/components/DadosEstatisticosBiblioteca.vue'
export default {
  components: {
    DadosEstatisticosBiblioteca
  }
}
</script>
